import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[wlReceiptConclusion]',
  standalone: true,
})
export class ReceiptConclusionDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
